import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-8 py-20 md:py-24 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20light%20trails%20in%20warm%20coral%20and%20amber%20tones%20on%20dark%20background%2C%20smooth%20gradient%20waves%20representing%20media%20streaming%20and%20connectivity%2C%20modern%20digital%20art%20style%2C%20elegant%20and%20dynamic%20composition&width=1920&height=600&seq=cta-media-02&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/90 via-foreground-900/80 to-foreground-900/90"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
          立即开始您的传媒在线观看之旅
        </h2>
        <p className="text-background-50/80 text-lg mb-8 leading-relaxed">
          无需注册，无需下载，打开浏览器即可畅享海量高清视频内容。<strong className="text-background-50">传媒在线观看，随时随地，精彩随行。</strong>
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/xinwen"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-base hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}